<template>
	<div>
		<el-dialog :visible.sync="showset" title="生成物流" width="1000px" :append-to-body="true" :close-on-click-modal="false">
			<div class="createstep">
			<el-card class="box-card" shadow="never" style="margin-top:-20px">
			<div>
				<el-form size="mini" :inline="true">
					<el-form-item label="常用模板">
						<el-select v-model="selectmode" :clearable="true" style="width:200px" placeholder="请选择模板" @change="changemode">
							<el-option
							     v-for="item in modelist" :key="item.index" :label="item.modename" :value="item.modename">
							      <span style="float: left">{{ item.modename }}</span>
							      <span style="float: right;">
									  <i class="el-icon-close" @click="delmode(item)"></i>
								  </span>
							</el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
			<div>
				<tableui
					ref="cargo"
					editcell="1"
					:tableData="steplist"
					:columns="columns"
					@gridhandle="gridhandle"
					@autoaddrow="gridhandle"
					:gridheight="gridheight"
				></tableui>
			</div>
		</el-card>
		<div slot="footer" style="margin-top:10px">
			<el-row>
				<el-col :span="3">
					<el-checkbox style="margin-left:10px" v-model="checked" @change="checkaddmode">存为模板</el-checkbox>
				</el-col>
				<el-col :span="checked?12:8" style="text-align:left;">
					<span style="color:transparent">1</span>
					<el-input placeholder="请输入模板名称" style="width:200px" type="text" v-model="newselectmode" v-if="checked" ref="modename" size="mini">
					</el-input>
					<el-button type="warning" size="mini" v-if="checked" @click="addmode" style="margin-left:10px">保存</el-button>
				</el-col>
				<el-col :span="checked?8:12" style="text-align:left;">
					<el-button type="success" size="mini" @click="createstep">确定生成</el-button>
					<el-button size="mini" @click="closestep" style="margin-left:10px">取 消</el-button>
				</el-col>
			</el-row>
		</div>
		</div>
		</el-dialog>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
import tableui from '@/components/table/tablegrid.vue';
export default {
	components: {
		tableui
	},
	data() {
		return{
			showset:false,
			selectmode:'',
			newselectmode:'',
			gridheight:'300px',
			checked:false,
			modelist:[],
			batch:'',//已选订单的临时表批次号
			pageparam:'',
			steplist:[],
			columns:[{ field: 'w_name', title: '步骤名', type: 'input', width: '100', sortable: false },{ field: 'context', title: '操作描述', type: 'input', width: '230', sortable: false },{ field: 'u_createtime', title: '操作时间', type: 'time', width: '170', sortable: false,event:'setsteptime',evttype:'change' },{ field: 'w_spanmiunts', title: '下一步增加分钟', type: 'input', width: '120', sortable: false,event:'setsteptime',evttype:'change' },
				{
					field: '',
					title: '操作',
					type: 'template',
					width: '120',
					sortable: false,
					template: [
						{ type: 'link', title: '新增', handletype: 'success', event: 'addrow' },
						{ type: 'link', title: '删除', handletype: 'danger', event: 'delrow' }
					]
				}],
			steplistempty:{
				w_name:'1',
				context:'',
				u_createtime:'',
				w_spanmiunts:''
			},
			allsteplist:[],
			divclass:'createstep'
		};
	},
	mounted() {
		
	},
	methods:{
		init(param){
			this.batch='';
			this.pageparam='';
			this.showset=true;
			this.checked=false;
			this.selectmode='';
			this.newselectmode='';
			this.allsteplist=[];
			this.steplist=[];
			this.modelist=[];
			if(param.batch!=undefined)
				this.batch=param.batch;
			if(param.pageparam!=undefined)
				this.pageparam=param.pageparam;
			this.steplist.push(JSON.parse(JSON.stringify(this.steplistempty)));
			this.loadmode();
		},
		loadmode(){
			var that=this;
			// [{step:'1',
			// 	remark:'已揽收',
			// 	createtime:this.$tool.formatdate(),
			// 	time:30},{step:'2',
			// 	remark:'飞往机场',
			// 	time:20}];
			this.$apipost.get.GetWlStep().then(res => {
				if(res.list!=undefined){
					that.allsteplist=res.list;
				}
				if(res.modelist!=undefined){
					that.modelist=res.modelist;
				}
			});
		},
		changemode(){
			var that=this;
			var list=that.allsteplist.filter(function(e){
				return e.modename==that.selectmode
			});
			// if(list.length>0){
			// 	var currenttime=this.$tool.formatdate();
			// 	var lasttime=0;
			// 	list.forEach(e=>{
			// 		if(e.u_createtime==undefined){
			// 			e.u_createtime=that.$tool.addgetdate('mm',parseInt(lasttime),currenttime);
			// 			currenttime=e.u_createtime;
			// 		}
			// 		lasttime=e.w_spanmiunts;
			// 	});
			// }
			this.steplist=list;
			this.setCurrenttime(true);
		},
		setCurrenttime(isload,index){
			debugger
			var that=this;
			var lasttime=0;
			var idx=0;
			if(index==undefined)
				index=0;
			var list=JSON.parse(JSON.stringify(this.steplist));
			if(list.length>0){
				var currenttime=this.$tool.formatdate();
				if(!isload){
					currenttime=this.steplist[index].u_createtime;
				}
				list.forEach(e=>{
					if(idx>=index){
						e.u_createtime=that.$tool.addgetdate('mm',parseInt(lasttime),currenttime);
						currenttime=e.u_createtime;
						lasttime=e.w_spanmiunts;
					}
					idx=idx+1;
				});
			}
			this.steplist=list;
		},
		checkaddmode(){
			var that=this;
			if(this.checked)
			{
				this.$nextTick(function(){
					that.$refs.modename.focus();
				});
			}
			else{
				this.newselectmode='';
			}
		},
		//保存物流模板
		addmode(){
			var that=this;
			if(this.newselectmode=='')
			{
				this.$tool.message('请输入模板名称',0);
				return false;
			}
			if(this.steplist.length==0)
			{
				this.$tool.message('请设置物流步骤',0);
				return false;
			}
			else{
				var index=0;
				var isgo=true;
				this.steplist.forEach(e=>{
					index++;
					if(e.w_name=='')
					{
						this.$tool.message('第 '+index+' 行请设置步骤名',0);
						isgo=false;
						return false;
					}
					if(e.context=='')
					{
						this.$tool.message('第 '+index+' 行请设置操作描述',0);
						isgo=false;
						return false;
					}
					if(e.u_createtime=='')
					{
						this.$tool.message('第 '+index+' 行请设置操作时间',0);
						isgo=false;
						return false;
					}
				});
				if(!isgo)
					return false;
			}
			//判断模板名称是否存在
			var list=that.modelist.filter(function(e){
				return e.modename==that.newselectmode;
			});
			if(list.length>0){
				this.$confirm('【'+this.newselectmode+'】已存在，确定要覆盖此模板吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				})
					.then(() => {
						that.addmode2(false);
					}).catch(() => {});
			}else
				this.addmode2(true);
		},
		addmode2(type){
			var that=this;
			var paraminfo={
				userid:localStorage.getItem('userid'),
				modename:that.newselectmode,
				list:that.steplist
			}
			this.$tool.loading('正在保存', this.divclass);
			this.$apipost.post.SaveWlStep({paraminfo:paraminfo}).then(res => {
				this.$tool.loadingclose();
				if(res.state=='1'){
					this.$tool.message('保存成功',1);
					if(type){
						that.modelist.push({modename:that.newselectmode});
					}
					
					that.selectmode=that.newselectmode;
					that.newselectmode='';
					that.checked=false;
				}
				else{
					this.$tool.message('保存失败',0);
				}
			});
		},
		//列表操作列
		gridhandle(e) {
			//debugger
			if (e.event == 'addrow') {
				this.steplistempty.w_name=e.index +2;
				this.steplist.splice(e.index + 1, 0,JSON.parse(JSON.stringify(this.steplistempty)));
				this.createnextstep(e.index);
			}
			if (e.event == 'delrow') {
				this.deleteRow(e);
			}
			if(e.event=='setsteptime')
			{
				//debugger
				//this.createnextstep(e.index);
				this.setCurrenttime(false,e.index);
			}
		},
		createnextstep(index){
			//debugger
			if(this.steplist.length>(index+1)){
				if(this.steplist[index].u_createtime!=''&&this.steplist[index].w_spanmiunts!=''){
					this.steplist[(index+1)].u_createtime=this.$tool.addgetdate('mm',parseInt(this.steplist[index].w_spanmiunts),this.steplist[index].u_createtime);
				}
			}
		},
		//删除行
		deleteRow(e) {
			this.steplist.splice(e.index,1);
			if (this.steplist.length < 1) {
				this.steplist.push(JSON.parse(JSON.stringify(this.steplistempty)));
			}
		},
		delmode(item){
			var that=this;
			this.$confirm('确定删除【'+item.modename+'】模板吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			})
				.then(() => {
					this.$tool.loading('正在删除',this.divclass);
					this.$apipost.post.DelWlStep({ modename: item.modename }).then(res => {
						this.$tool.loadingclose();
						if (res.state == '1') {
							this.$tool.message('删除成功', 1);
							var list=that.modelist;
							var index=0;
							list.forEach(e=>{
								if(e.modename==item.modename)
									return false;
								index=index+1;
							});
							that.modelist.splice(index,1);
							if(that.selectmode==item.modename)
								that.selectmode='';
						} else {
							this.$tool.message('删除失败', 0);
						}
					});
				}).catch(() => {});
		},
		//生成物流步骤
		createstep(){
			var that=this;
			if(this.batch==''&&this.pageparam==''){
				this.$tool.message('未获取到订单',0);
				return false;
			}
			if(this.steplist.length==0)
			{
				this.$tool.message('请设置物流步骤',0);
				return false;
			}
			else{
				var index=0;
				var isgo=true;
				this.steplist.forEach(e=>{
					index++;
					if(e.w_name=='')
					{
						this.$tool.message('第 '+index+' 行请设置步骤名',0);
						isgo=false;
						return false;
					}
					if(e.context=='')
					{
						this.$tool.message('第 '+index+' 行请设置操作描述',0);
						isgo=false;
						return false;
					}
					if(e.u_createtime=='')
					{
						this.$tool.message('第 '+index+' 行请设置操作时间',0);
						isgo=false;
						return false;
					}
				});
				if(!isgo)
					return false;
			}
			var paraminfo={
				batch:this.batch,
				pageparam:this.pageparam,
				steplist:this.steplist,
				userid:localStorage.getItem('userid'),
				handleraccount:localStorage.getItem('u_account')
			};
			//console.log('生成物流',encodeURIComponent(JSON.stringify(paraminfo)));
			this.$tool.loading('正在生成',this.divclass);
			this.$apipost.post.CreateOrderStep({ paraminfo: paraminfo }).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					this.$tool.message('生成成功', 1);
					setTimeout(function(){
						that.showset=false;
					},1000);
				} else {
					this.$tool.message('生成失败', 0);
				}
			});
		},
		closestep(){
			this.showset=false;
		}
	}
}	
</script>

<style>
</style>
